import { KEY_CODES } from '../../../../utils/keyboard/keyConstants';

/**
 * Maps the relevant keyboard shortcuts to image modal zoom actions.
 */
export const getImageModalZoomKeyboardAction = (keyCode: number): 'zoomIn' | 'zoomOut' | 'reset' | null => {
    switch (keyCode) {
        case KEY_CODES.EQUAL:
        case KEY_CODES.ADD:
            return 'zoomIn';
        case KEY_CODES.DASH:
        case KEY_CODES.SUBTRACT:
            return 'zoomOut';
        case KEY_CODES['0']:
            return 'reset';
        default:
            return null;
    }
};
